import type { TFunction } from 'i18next'
import { formatMoneyCents } from '@/shared/lib/formatMoney'

/** Informational local-currency line (never a settlement amount). */
export type DisplayPriceHint = {
  amount_cents: number
  currency: string
} | null | undefined

export function formatDisplayPriceHint(
  t: TFunction,
  display: DisplayPriceHint,
  i18nKey = 'reservation.properties.detail.display_price',
): string | undefined {
  if (display?.amount_cents == null || !display.currency) {
    return undefined
  }
  return t(i18nKey, {
    amount: formatMoneyCents(display.amount_cents, display.currency),
    currency: display.currency,
  })
}
